import { Fragment } from "react";
import { Link } from "@chakra-ui/react";
import type { Copy, CopyNode } from "@/content";

const renderNode = (node: CopyNode, key: number) => {
  if (typeof node === "string") {
    return <Fragment key={key}>{node}</Fragment>;
  }

  if (node.type === "trademark") {
    return <sup key={key}>™</sup>;
  }

  if (node.type === "break") {
    return <br key={key} />;
  }

  return (
    <Link
      key={key}
      variant="inline"
      href={node.href}
      isExternal={node.external}
      rel={node.external ? "noopener" : undefined}
    >
      {node.text}
    </Link>
  );
};

export const RichText = ({ nodes }: { nodes: Copy }) => <>{nodes.map(renderNode)}</>;
